import { termIdsAtom } from '@activities/terms/TermDetailActivity/atoms/termAtoms';
import termQueries from '@apis/queries/termQueries';
import BottomSheetHeader from '@components/BottomSheetHeader';
import Column from '@components/Column';
import Radio from '@components/Radio';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

interface Params {
    termCategoryId: string;
}

declare module '@stackflow/config' {
    interface Register {
        TermSelectBottomSheet: Params;
    }
}

/** 약관 상세에서 볼 약관 선택. 선택하는 즉시 상세 화면에 반영하고 닫는다. */
const TermSelectBottomSheet: ActivityComponentType<'TermSelectBottomSheet'> = ({ params }) => {
    const { t } = useTranslation('termDetail');
    const { pop } = useFlow();
    const { termCategoryId } = params;
    const { data } = useQuery(termQueries.list(termCategoryId));
    const [termIds, setTermIds] = useAtom(termIdsAtom);
    const termId = termIds[termCategoryId];
    const handleChange = (id: string) => {
        setTermIds((prev) => ({ ...prev, [termCategoryId]: id }));
        pop();
    };
    return (
        <BottomSheet>
            <BottomSheetHeader>
                {t('filter.title')}
            </BottomSheetHeader>
            <Options fullWidth>
                {data?.terms?.map((term) => (
                    <Option key={term.id}>
                        <Radio value={term.id}
                            isSelected={termId === term.id}
                            onChange={handleChange}>
                            {term.title}
                        </Radio>
                    </Option>
                ))}
            </Options>
        </BottomSheet>
    );
};

const Options = styled(Column)`
    max-height: 60vh;
    overflow-y: auto;
    padding: var(--spacing-2) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
`;

const Option = styled.div`
    padding: var(--spacing-2) 0;
    width: 100%;
`;

export default TermSelectBottomSheet;
